import color from '@material-ui/core/colors/amber';
import { List, ListItem } from 'material-ui/List';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../actions/actions.jsx';
import cardPreference from '../../images/cardpreferencesicon.png';
import defaultImage from '../../images/default.gif';
import locationimg from '../../images/location.svg';
import {
    Link, NavLink, withRouter
} from 'react-router-dom';

const styles = {
    activeStyle: {
        backgroundColor: "#fff",
        boxShadow: "0 0px 0px 0px rgba(42, 81, 148, 0.2), 0 16px 16px -11px rgba(42, 81, 148, 0.6)",
        border: "1px solid #f5f5f5",
        borderBottom: "2px solid #333",
    }
}

const mapStateToProps = state =>
({
    profileState: state.getProfileReducer.profileState,
    display: state.getProfileReducer.display,
    optionState: state.selectedTabReducer.selectedTabReducer,

})

const mapDispatchToProps = dispatch =>
({
    fetchProfileState() {
        dispatch(
            actions.getProfileAction()
        )
    },
    fetchSelectedTab(selectedOption) {
        dispatch(
            actions.selectedtabAction(selectedOption)
        )
    },
    clearInput() {
        dispatch(
            actions.clearInputAction()
        )
    },
    clearProfile() {
        dispatch(
            actions.clearProfileAction()
        )
    }
})

class LeftLink extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedOption: '',
            mediaInfo: ''
        }
    }
    componentDidMount() {
        this.props.fetchProfileState()
        this.props.fetchSelectedTab(localStorage.getItem("taboption"))

    }
    componentWillMount() {
    }

    handleProfile(e) {
        let _this = this
        const { profileState } = this.props
        if (localStorage.getItem("comp") === "profilecomp") {
            this.setState({
                selectedOption: "tab1"
            }, () => {
                _this.props.fetchSelectedTab(this.state.selectedOption)
                _this.props.callBackFromParent()
            })
        }
        else {
            this.setState({
                selectedOption: "tab1"
            }, () => {
                localStorage.setItem("taboption", "tab3")
                _this.props.fetchSelectedTab(this.state.selectedOption)
                _this.props.history.push("/my-profile/" + profileState.body.firstName + "." + profileState.body.lastName)

            })
        }

    }
    handleCards(e) {
        this.props.history.push("/upgrade-my-card")
    }
    handleAlerts(e) {
        let _this = this;
        const { profileState } = this.props

        if (localStorage.getItem("comp") === "profilecomp") {
            this.setState({
                selectedOption: "tab3"
            }, () => {
                _this.props.fetchSelectedTab(this.state.selectedOption)
                _this.props.callBackFromParent()
            })
        }
        else {
            this.setState({
                selectedOption: "tab3"
            }, () => {
                localStorage.setItem("taboption", "tab3")
                _this.props.fetchSelectedTab(this.state.selectedOption)
                _this.props.history.push("/my-profile/" + profileState.body.firstName + "." + profileState.body.lastName)

            })
        }


    }
    handleLoadcard(e) {
        this.props.history.push("/loadcard")
    }
    handleFriends(e) {
        this.props.history.push("/friends&family")
    }
    handleLogout(e) {
        localStorage.clear();
        this.props.clearInput()
        this.props.clearProfile()
        this.props.history.push("/logout")

    }


    render() {
        const { profileState } = this.props
        //const {mediaInfo}=this.state
        var cardTypes = localStorage.getItem('cardTypes')
        return (
            <div>
                {profileState.status === 200 ?
                    <figure className="snip1344">
                        {profileState.body.profilePicture !== null ?
                            <Link to="/manage-my-profile">
                                <img src={"data:image/jpeg;base64," + profileState.body.profilePicture.mediaInfo || defaultImage} alt="profile-sample1" className="profile " /></Link> : <img src={defaultImage} alt="profile-sample1 " className="profile " />}
                        <figcaption>
                            <h4>{(profileState.body.firstName !== "" && profileState.body.firstName !== null) ? profileState.body.firstName + " " + profileState.body.lastName : ""}<span><img src={locationimg} alt="" />{profileState.body.city}</span></h4>
                        </figcaption>
                    </figure>
                    : <div></div>
                }

            </div>
        );
    }
}
LeftLink.defaultProps = {
    profileState: {
        status: 400
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LeftLink));


// WEBPACK FOOTER //
// ./src/components/leftlink/leftlink.jsx